import {ControlValueAccessor, FormArray, FormGroup, NG_VALUE_ACCESSOR} from '@angular/forms';
import {forwardRef} from '@angular/core';

export function MakeAccessor(type: any): { provide: any, useExisting: any, multi: boolean } {
  return { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => type), multi: true };
}

export abstract class ValidateAccessor {
  innerValidate?(): boolean;
}

export class AbstractValueAccessor extends ValidateAccessor implements ControlValueAccessor {

  disabled = false;
  localValidateForm = new FormGroup({});
  onChanged = (_: any) => {};
  onTouched: () => void = () => {};

  registerOnChange(fn: (v: any) => void): void {
    this.localValidateForm.valueChanges.subscribe(fn);
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    if (isDisabled) {
      this.localValidateForm.disable();
    } else {
      this.localValidateForm.enable();
    }
  }

  writeValue(obj: any): void {
    if (obj) {
      this.localValidateForm.patchValue(obj);
    }
  }
}

export class AbstractArrayValueAccessor extends ValidateAccessor implements ControlValueAccessor {

  disabled = false;
  localValidateForm = new FormArray([]);
  onChanged = (_: any) => {};
  onTouched: () => void = () => {};

  registerOnChange(fn: any): void {
    this.localValidateForm.valueChanges.subscribe(fn);
    this.onChanged = fn;
    // this.onChanged(this.localValidateForm.value);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    if (isDisabled) {
      this.localValidateForm.disable();
    } else {
      this.localValidateForm.enable();
    }
  }

  writeValue(obj: any): void {
    if (obj) {
      this.localValidateForm.patchValue(obj);
    }
  }
}

export abstract class SingleValueAccessor implements ControlValueAccessor {
  disabled = false;
  onChanged = (_: any) => {};
  onTouched = (_: any) => {};

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  abstract writeValue(obj: any);
}
